import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { constant } from 'app/app.constants';
import { ParentService } from 'app/pages/A2-utils/ParentClass/ParentService';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { INoteTemplate, INoteTemplateFilter } from '../interfaces/note.interface';
import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { buildQueryString } from '../../utils/helpers';

@Injectable()
export class NoteTemplateService extends ParentService {

  private noteTemplateDataSubject: BehaviorSubject<INoteTemplate[]> = new BehaviorSubject(null);
  noteTemplateData$: Observable<INoteTemplate[]> = this.noteTemplateDataSubject.asObservable();

  private noteTemplateDataByClickSubject: Subject<INoteTemplate> = new Subject();
  noteTemplateDataByClick$: Observable<INoteTemplate> = this.noteTemplateDataByClickSubject.asObservable();

  constructor(private http: Http) {
    super();
  }

  getTemplateNote(filters: INoteTemplateFilter = { showInactive: false }): Observable<INoteTemplate[]> {
    return this.http
      .get(`${constant.URL_TRIP_NOTES_TEMPLATE_BASE}${buildQueryString(filters)}`, this.getHeader())
      .map((res) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  addNoteTemplate(data: any): Observable<any> {
    return this.http
      .post(constant.URL_TRIP_NOTES_TEMPLATE_BASE, data, this.headerPost())
      .pipe(map((response: any) => response.json()))
      .catch((error: any) => Observable.throw(error.json()));
  }

  updateNoteTemplate(data: any): Observable<any> {
    return this.http
      .put(constant.URL_TRIP_NOTES_TEMPLATE_BASE, data, this.headerPost())
      .pipe(map((response: any) => response.json()))
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * Sends note template data to subscribers.
   * @param data - The note template data to send.
   */
  sendNoteTemplateData(data: INoteTemplate[]): void {
    this.noteTemplateDataSubject.next(data);
  }

  /**
   * Sends note template data for a specific note to subscribers.
   * @param data - The note template data to send.
   */
  sendNoteTemplateDataByClick(data: INoteTemplate): void {
    this.noteTemplateDataByClickSubject.next(data);
  }

  /**
   * Clears the note template data.
   */
  clearNoteTemplateData(): void {
    this.noteTemplateDataSubject.next(null);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/note-template.service.ts